<template>
    <app-layout title="Builder">
        <PageTitle :headerTitle="title"> </PageTitle>
        <div class="max-w-6xl mx-auto">
            <!-- Header -->
            <div class="w-full bg-white p-2 mb-8 rounded-lg">
                <h1 class="text-[#000000] text-sm font-normal">
                    Add New Child Module <span class="text-[#d4d4d4]">/ Dashboard</span>
                </h1>
            </div>

            <!-- Main content -->
            <form class="form-horizontal" @submit.prevent="submit">
                <div>
                    <input class="
              bg-blue-500
              text-white text-xs
              hover:bg-blue-700
              py-1
              px-3
              rounded
            " type="submit" value="Save" />
                </div>
                <div class="mt-8 p-4 bg-white" v-for="(createDef, formKey) in groupedForms" :key="formKey">
                    <ChildBsEdit :slug="slug"  v-model="checkboxStatus" :createDef="createDef" :selectedDropdownOption="selectedDropdownOption" :routeDef="moduleRoute"
                        ref="formRenderer" @itemSelected="handleItemSelected">
                    </ChildBsEdit>
                </div>
            </form>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { DxToast } from "devextreme-vue/toast";
import PageTitle from "@/Layouts/PageTitle.vue";
import ChildBsEdit from "@/Base/ChildBsEdit.vue";
import { Inertia } from '@inertiajs/inertia';

export default {
    props: {
        isDeployed: Boolean,
        createDef: Array,
        selectedDropdownOption: String,
        moduleRoute: String,
        baseModule: String,
        dependentOptions: Array,
        slug: String,
        isStudio: Boolean,
        modules: Array,
        moduleData: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        AppLayout,
        PageTitle,
        ChildBsEdit,
        DxToast,
    },
    data() {
        return {
            txt: "kk",
            title: "Create Child Module",
            form: this.$inertia.form(),
            isVisible: false,
            is_general: this.moduleData.module_type == "general" ? true : false,
            message: "",
            type: "success",
            checkboxStatus: [],
            errors: {},
        };
    },
    computed: {
        groupedForms() {
            return this.createDef.reduce((acc, field) => {
                acc[field.form] = acc[field.form] || [];
                acc[field.form].push(field);
                return acc;
            }, {});
        }
    },
    methods: {        
        /* Submit form data */
        // submit() {
        //     let length = this.$refs.formRenderer.length;
        //     let formDataObject = {};
        //     let formData = {};           

        //     for (let i = 0; i < length; i++) {
        //         // Using the getFormData method which includes the dependent select values
        //         formData = {
        //             ...this.$refs.formRenderer[i].getFormData(),
        //             route_slug: this.slug,
        //             formType: "childModuleForm"
        //         };

        //         if (i === 0) {
        //             // Append dropdown values only for index 0
        //             formData.dropdownList = formData.dropdownListSelection;
        //             formData.defaultList = formData.defaultListSelection;

        //             console.log({
        //                 dropdownList: formData.dropdownList,
        //                 defaultList: formData.defaultList
        //             });
        //         }               


        //         formDataObject = { ...formDataObject, ...formData };
        //     }
        //     console.log("formData: ",formData);

        //     let formatData = {                   
        //         "name": formDataObject.field_name,
        //         "label": formDataObject.field_label,
        //         "options": formDataObject.dropdownList,
        //         "default": formDataObject.defaultList,
        //         "editorType":"subModuleField",
        //     };  

        //     console.log("FormDataObject: ",formDataObject); 

        //     this.errors = {};

        //     axios
        //         .post("/" + this.slug + "/field", {
        //             module: this.baseModule,
        //             studio: this.isStudio,
        //             data: formatData,
        //         })
        //         .then((response) => {
        //             console.log("Response:", response);
        //             // window.location.href =
        //             //     "/" + this.slug + "/module/" + this.modulekey + "/fields";
        //         })
        //         .catch((error) => {
        //             if (error.response.status === 422) {
        //                 this.errors = error.response.data.errors || {};
        //             }
        //         });

        //     console.log("Complete formData being submitted:", formDataObject);
        //     this.form.post(route(this.moduleRoute + ".index", formDataObject));
        // },
        submit() {    
            console.log('Base Module:', this.baseModule);        
            let length = this.$refs.formRenderer.length;
            let formDataObject = {};
            let formData = {};
            let relateFieldsData = {};  // To collect all relate field data

            for (let i = 0; i < length; i++) {
                // Using the getFormData method which includes all values
                const currentFormData = this.$refs.formRenderer[i].getFormData();
                console.log("Current form data:", currentFormData);
                formData = {
                    ...currentFormData,
                    route_slug: this.slug,
                    formType: "childModuleForm"
                };

                // Collect relate field data specifically
                if (currentFormData.relateFieldValues) {
                    relateFieldsData = { ...relateFieldsData, ...currentFormData.relateFieldValues };
                }

                if (i === 0) {
                    // Append dropdown values only for index 0
                    formData.dropdownList = formData.dropdownListSelection;
                    formData.defaultList = formData.defaultListSelection;

                    console.log({
                        dropdownList: formData.dropdownList,
                        defaultList: formData.defaultList
                    });
                }

                formDataObject = { ...formDataObject, ...formData };
            }

            // Add the collected relate fields data to the main form object
            formDataObject.relateFieldValues = relateFieldsData;

            console.log("formData with relate fields:", formData);

            let formatData = {
                "name": formDataObject.field_name,
                "label": formDataObject.field_label,
                "options": formDataObject.dropdownList,
                "default": formDataObject.defaultList,
                "editorType": "subModuleField",
                "relateFields": formDataObject.baseModuleName // Contains both IDs and names
            };            

            // return;
            this.errors = {};

            axios
                .post("/" + this.slug + "/field", {
                    module: this.baseModule,
                    studio: this.isStudio,
                    data: formatData,
                })
                .then((response) => {
                    console.log("Response:", response);
                    // Show success message
                    this.message = "Field created successfully!";
                    this.type = "success";
                    this.isVisible = true;

                    // Redirect after success if needed
                    // window.location.href = "/" + this.slug + "/module/" + this.baseModule + "/fields";
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.errors = error.response.data.errors || {};
                        this.message = "Validation error. Please check the form.";
                        this.type = "error";
                        this.isVisible = true;
                    } else {
                        this.message = "An error occurred. Please try again.";
                        this.type = "error";
                        this.isVisible = true;
                    }
                });
            
            this.form.post(route(this.moduleRoute + ".index", formDataObject));
        },
    },
    mounted() {      
        
    },
};
</script>